var _rect, _rect2, _rect3, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsSelectAllWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27934",
    "data-name": "Group 27934",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.656,
    height: 17.973,
    viewBox: "0 0 26.656 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7911",
    "data-name": "Rectangle 7911",
    width: 20,
    height: 3,
    transform: "translate(0 6.236)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7912",
    "data-name": "Rectangle 7912",
    width: 20,
    height: 3,
    transform: "translate(0)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7913",
    "data-name": "Rectangle 7913",
    width: 12,
    height: 3,
    transform: "translate(0 12.473)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16650",
    "data-name": "Path 16650",
    d: "M23.524,11.93l-5.853,5.839-2.92-2.92L12.81,16.791l4.861,4.875,7.795-7.795Z",
    transform: "translate(1.19 -3.694)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsSelectAllWhiteIcon);
export default __webpack_public_path__ + "static/media/gs-selectAll-whiteIcon.3732b52d72d67ee8e15b2c8fdbde188c.svg";
export { ForwardRef as ReactComponent };